import _ from 'lodash';
import { ViewAgentEngagementEvent } from './view-agent-engagement-event';

export class GroupedViewAgentEngagementEvent {
	// for internal use
	public groupedJson: string;

	public activeAgentEngagementEventBrokerGroups: { [key: string]: ViewAgentEngagementEvent[] };
	public activeAgentEngagementEventCategoryGroups: { [key: number]: ViewAgentEngagementEvent[] };
	public followUpAgentEngagementEventBrokerGroups: { [key: string]: ViewAgentEngagementEvent[] };
	public followUpAgentEngagementEventCategoryGroups: { [key: number]: ViewAgentEngagementEvent[] };

	constructor(groupedViewAgentEngagementEvent: GroupedViewAgentEngagementEvent) {
		Object.assign(this, groupedViewAgentEngagementEvent);

		if (this.groupedJson) {
			const result = JSON.parse(this.groupedJson);
			this.activeAgentEngagementEventBrokerGroups = result.activeAgentEngagementEventBrokerGroups;
			this.activeAgentEngagementEventCategoryGroups = result.activeAgentEngagementEventCategoryGroups;
			this.followUpAgentEngagementEventBrokerGroups = result.followUpAgentEngagementEventBrokerGroups;
			this.followUpAgentEngagementEventCategoryGroups = result.followUpAgentEngagementEventCategoryGroups;
		}
	}

	get agentEngagementEventBrokers(): string[] {
		return _.chain(this.activeAgentEngagementEventBrokerGroups)
			.keys()
			.concat(_.keys(this.followUpAgentEngagementEventBrokerGroups))
			.orderBy(b => b)
			.sortedUniq()
			.value();
	}
}
